import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Form, Formik, Field } from 'formik';
import React from 'react';
import { toast } from 'react-toastify';
import DialogTitle from 'v2/components/Shared/DialogTitle';
import TextFormField from 'v2/components/Shared/FormFields/TextFormField';
import helpService from 'v2/services/help';

import { newTicketSchema } from './validation';

import type { FormikProps } from 'formik';

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
}

interface IFormikValues {
  title: string;
  description: string;
}

const useStyles = makeStyles(() => ({
  actions: {
    padding: '16px 24px',
  },
}));

const NewTicketModal = ({ isOpen, handleClose }: IProps) => {
  const classes = useStyles();

  const onSubmit = ({ title, description }: IFormikValues, { setSubmitting }: FormikProps<IFormikValues>) => {
    helpService.newTicket(title, description).subscribe(
      () => {
        toast.success('Ticket criado com sucesso!');
        setSubmitting(false);
        handleClose();
      },
      () => {
        toast.error('Erro ao criar ticket!');
        setSubmitting(false);
        handleClose();
      }
    );
  };

  return (
    <Dialog open={isOpen}>
      <Formik initialValues={{ title: '', description: '' }} onSubmit={onSubmit} validationSchema={newTicketSchema}>
        {({ dirty, isValid, isSubmitting }) => (
          <Form>
            <DialogTitle onClose={handleClose}>
              <Typography variant='h6'>Novo ticket</Typography>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Field
                    id='title'
                    name='title'
                    label='Título'
                    fullWidth
                    component={TextFormField}
                    inputProps={{
                      maxLength: 50,
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Field
                    id='description'
                    name='description'
                    label='Descrição'
                    component={TextFormField}
                    fullWidth
                    multiline
                    rows={6}
                    rowsMax={6}
                    inputProps={{
                      maxLength: 1500,
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.actions}>
              <Button onClick={handleClose}>Fechar</Button>
              <Button variant='contained' color='primary' disabled={!dirty || !isValid || isSubmitting} type='submit'>
                Enviar
                {isSubmitting && <CircularProgress size={16} style={{ marginLeft: 10 }} />}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default NewTicketModal;
